import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav `
  ${siteWide};

  --siteWidth: 1550px;

  @media ${from(Device.TabletLarge)} {
    width: 100%;
    max-width: var(--maxWidth);
  }
`;
const List = styled.ul `
  display: flex;
  align-items: stretch;
  height: 100%;
  justify-content: space-between;
`;
const Item = styled.li `
  display: grid;
  align-items: center;

  &[data-type='simple'] {
    position: relative;
  }
`;
const Link = styled.a `
  display: flex;
  align-items: center;
  color: currentColor;
  ${fonts.brandonGrotesque.medium};
  font-size: 16px;
  line-height: 1em;
  text-decoration: none;
  text-underline-position: under;

  ${Item}:focus-within &,
  &:hover {
    text-decoration: underline;
  }
`;
const Icon = styled.span `
  display: inline-block;
  height: 6px;
  margin-left: 6px;
  width: 11px;
`;
const NavigationDesktopStyles = {
    Container,
    Icon,
    Item,
    Link,
    List,
};
export default NavigationDesktopStyles;
